module.exports = __webpack_public_path__ + "static/media/22ESCWA20.2d3e90ff.jpg";